module.exports = __webpack_public_path__ + "img/banner-home-20230901.ddf2c6d5.jpg";